var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"images"},[(_vm.initialized && _vm.ready)?_c('admin-images',{attrs:{"imageSizes":_vm.imageSizes,"links":_vm.imageLinks}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }